import { styled } from 'styled-components';

import SelfImprovementSVG from '../assets/improvement-icon.svg?react';

export const StyledSelfImprovementIcon = styled(SelfImprovementSVG)`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;
